import React from 'react'
import MuiAlert from '@mui/material/Alert'

interface AlertProps {
  children: string | React.ReactNode
  severity: 'error' | 'success' | 'info' | 'warning'
  action?: JSX.Element
}

const Alert = (props: AlertProps): JSX.Element => {
  return (
    <MuiAlert severity={props.severity} action={props.action}>
      {props.children}
    </MuiAlert>
  )
}

export default Alert
